import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import BottomPagination from '../../components/Pagination/BottomPagination/BottomPagination';
import TopPagination from '../../components/Pagination/TopPagination/TopPagination';
import {
  CommonFlex,
  CommonGrid,
  HeaderContainer,
  PageTitle,
} from '../../styledComponents/common';
import CardsList from './CardsList';
import EvidenceFilter from './EvidenceFilter';

const Evidence = props => {
  const {
    selectedOrganization,
    organizationMembersList,
    getOrganizationMembersList,
    getEvidenceList,
    isEvidenceLoading,
    evidenceList,
    evidenceCount,
    officesShortList,
    getOfficesShortList,
    pageSize,
  } = props;

  const { t } = useTranslation();
  const [selectedMember, setSelectedMember] = useState('');
  const [currentSearchedTerm, setCurrentSearchedTerm] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearchActive, setIsSearchActive] = useState(false);

  // Pagination
  const [currentPagination, setCurrentPagination] = useState(1);

  const [selectedOffice, setSelectedOffice] = useState({
    label: t('all_offices'),
    value: null,
  });
  const [selectedDate, setSelectedDate] = useState({
    startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  });

  // Add this useEffect to load evidence data when component mounts
  useEffect(() => {
    // Initial API call when component mounts
    const initialPayload = {
      startDate: selectedDate.startDate,
      endDate: selectedDate.endDate,
      officeId: selectedOffice.value,
      userId: selectedMember.id,
      page: currentPagination,
      taskCode: searchTerm,
    };

    getEvidenceList(initialPayload);

    // Also load organization members list if needed
    if (selectedOrganization && getOrganizationMembersList) {
      getOrganizationMembersList();
    }

    // Load offices list if needed
    if (getOfficesShortList) {
      getOfficesShortList();
    }
  }, [selectedOrganization]); // Only re-run if selectedOrganization changes

  useEffect(() => {
    if (!isSearchActive) return;

    const payload = {
      startDate: selectedDate.startDate,
      endDate: selectedDate.endDate,
      officeId: selectedOffice.value,
      userId: selectedMember.id,
      page: currentPagination,
      taskCode: searchTerm,
    };

    getEvidenceList(payload);
    setIsSearchActive(false);
  }, [
    isSearchActive,
    selectedMember,
    selectedDate,
    selectedOffice,
    currentPagination,
    searchTerm,
  ]);

  const selectMember = person => {
    setSelectedMember(person);
    setIsSearchActive(true);
    setCurrentPagination(1);
  };

  const selectDate = date => {
    setSelectedDate({
      startDate: moment(date.startDate).format('YYYY-MM-DD'),
      endDate: moment(date.endDate).format('YYYY-MM-DD'),
    });
    setIsSearchActive(true);
    setCurrentPagination(1);
  };

  const selectOffice = office => {
    setCurrentPagination(1);
    setSearchTerm('');
    setCurrentSearchedTerm('');
    setSelectedOffice(office);
    setIsSearchActive(true);
  };

  const clearMember = () => {
    setSelectedMember('');
    setSearchTerm('');
    setCurrentSearchedTerm('');
    setCurrentPagination(1);
    setIsSearchActive(true);
  };

  const onSearchTermChange = e => {
    setIsSearchActive(false);
    setSearchTerm(e.target.value);
  };

  const handlePageChange = page => {
    setCurrentPagination(page);
    setIsSearchActive(true);
  };

  const handleSearchByName = () => {
    setCurrentSearchedTerm(searchTerm);
    setIsSearchActive(true);
    setCurrentPagination(1);
  };
  const handleClearSearch = () => {
    setSearchTerm('');
    setCurrentSearchedTerm('');
    setIsSearchActive(true);
  };

  return (
    <div className="content">
      <CommonGrid alignItem="center">
        <PageTitle>{t('evidence_image')}</PageTitle>
      </CommonGrid>
      <HeaderContainer>
        <EvidenceFilter
          selectedOrganization={selectedOrganization}
          organization={selectedOrganization}
          membersList={organizationMembersList}
          getOrganizationMembersList={getOrganizationMembersList}
          officesShortList={officesShortList}
          getOfficesShortList={getOfficesShortList}
          selectMember={selectMember}
          handleDateChange={selectDate}
          selectedMember={selectedMember}
          clearMember={clearMember}
          selectedOffice={selectedOffice}
          selectOffice={selectOffice}
          searchTerm={searchTerm}
          onSearchTermChange={onSearchTermChange}
          handleSearchByName={handleSearchByName}
          handleClearSearch={handleClearSearch}
        />
      </HeaderContainer>
      {evidenceCount && evidenceCount > 0 && pageSize ? (
        <TopPagination
          itemName={t('Tasks')}
          totalCount={evidenceCount}
          currentPage={currentPagination}
          onPageChange={page => handlePageChange(page)}
          pageSize={pageSize}
        />
      ) : null}
      <CardsList
        isLoading={isEvidenceLoading}
        evidenceList={evidenceList}
        count={evidenceCount}
      />
      {evidenceCount && evidenceCount > 0 && pageSize ? (
        <BottomPagination
          totalCount={evidenceCount}
          currentPage={currentPagination}
          onPageChange={page => handlePageChange(page)}
          pageSize={pageSize}
        />
      ) : null}
    </div>
  );
};

export default Evidence;
